import { makeDocumentMockData } from '../../modules/documentMockDataFactory'
import type { ICompanyMSDocument } from '~/types/document/models'

export const {
  getDocumentListData: getCompanyMSDocumentListData,
  getDocumentDataById: getCompanyMSDocumentDataById,
  getDocumentListDataByParentId: getCompanyMSDocumentListDataByCMSId,
} = makeDocumentMockData<ICompanyMSDocument>({
  entityName: 'companyMasterService',
  storageKeyPrefix: 'companyms',
})
